import { Toaster } from 'react-hot-toast'

// Re-export toast for convenient use throughout the app
// eslint-disable-next-line react-refresh/only-export-components -- re-export of a library function, imported by 10 files
export { toast } from 'react-hot-toast'

/**
 * Mount once in Layout. Reads the current theme for proper colors.
 */
export default function Toast() {
  return (
    <Toaster
      position="bottom-right"
      gutter={8}
      toastOptions={{
        duration: 3500,
        style: {
          background: 'var(--bg-surface)',
          color: 'var(--text-primary)',
          border: '1px solid var(--border)',
          borderRadius: '12px',
          fontSize: '14px',
          fontFamily: 'var(--font-ui)',
          boxShadow: 'var(--shadow-float)',
          padding: '12px 16px',
          maxWidth: '380px',
        },
        success: {
          iconTheme: { primary: 'var(--success)', secondary: 'var(--bg-surface)' },
        },
        error: {
          iconTheme: { primary: 'var(--danger)', secondary: 'var(--bg-surface)' },
          duration: 5000,
        },
      }}
    />
  )
}
